import { render, staticRenderFns } from "./Oportunities.vue?vue&type=template&id=3ac6f7a5&scoped=true&"
import script from "./Oportunities.vue?vue&type=script&lang=ts&"
export * from "./Oportunities.vue?vue&type=script&lang=ts&"
import style0 from "./Oportunities.vue?vue&type=style&index=0&id=3ac6f7a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac6f7a5",
  null
  
)

export default component.exports